import { IoMailOutline } from "react-icons/io5";
import { MdOutlineEmail } from "react-icons/md";
import { VscMail } from "react-icons/vsc";

const Mail = ({
  id,
  name,
  placeholder,
  type = "text",
  required,
  icon = null,
}) => {
  return (
    <div className="flex items-center bg-[#FFFFFF] rounded-lg p-2 h-12 w-96 tc1:w-80 md:w-full  mt-4">
      {/* Icon on the left */}
      {icon ? (
        icon
      ) : (
        <MdOutlineEmail className="text-[#000000] text-lg mr-4 ml-3 " />
      )}
      {/* Input field */}
      <input
        type={type}
        id={id}
        name={name}
        placeholder={placeholder}
        className="flex-1 outline-none bg-[#FFFFFF] "
        required={required ? true : false}
      />
    </div>
  );
};

export default Mail;
